<div class="loading-container flex-content-center" [class.active]="_loadingService.loading">
  <div class="case__loading">
    <div class="big__circle">
      <div class="inner__circle"></div>
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stop-color="#0002ee" />
              <stop offset="50%" stop-color="#0001ad" />
              <stop offset="100%" stop-color="#0002ee" />
            </linearGradient>
          </defs>
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke="url(#gradient)"
          />
        </svg>
      </div>
    </div>
  </div>
</div>
